
window.$ = window.jQuery = require('jquery');
require('bootstrap');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
 window.Popper = require('popper.js').default;
 window.$ = window.jQuery = require('jquery');
 window.datepicker = require('bootstrap-datepicker/js/bootstrap-datepicker')
 
 require('bootstrap');
} catch (e) {}

require('../../../node_modules/bootstrap-fileinput/js/fileinput.min');
require('../../../node_modules/bootstrap-fileinput/themes/fas/theme');
